import * as R from 'ramda';

const hasUpperCase = R.test(/[A-Z]/);
const hasTrailingSlash = _ => _.charAt(_.length - 1) === '/';
const removeLastChar = _ => _.substring(0, _.length - 1);

const urlNeedsRedirect = R.either(hasUpperCase, hasTrailingSlash);

const redirectExcludeList = ['/used-cars/dealer/:id'];

export const shouldRedirect = match =>
  !redirectExcludeList.includes(match.path) && urlNeedsRedirect(match.url);

export const buildRedirectUrl = url => {
  if (hasTrailingSlash(url)) {
    url = removeLastChar(url);
  }
  return url.toLowerCase();
};



// WEBPACK FOOTER //
// ./src/Common/redirect/index.js